import { render } from "./qna.vue?vue&type=template&id=16195942&scoped=true"
import script from "./qna.vue?vue&type=script&lang=js"
export * from "./qna.vue?vue&type=script&lang=js"

import "./qna.vue?vue&type=style&index=0&id=16195942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16195942"]])

export default __exports__